import React from 'react';
import {useTranslation} from "@Translation/hooks/useTranslation";
import SidebarSectionContainer from "../Sections/SidebarSectionContainer";
import BlogPosts from "../BlogPosts/BlogPosts";
import LatestBlogType from "@Sidebar/types/LatestBlog.type";
import IconGuide from "@Icons/IconGuilde";

interface GuidesContainerProps {
    latestGuides: LatestBlogType[],
}

function GuidesContainer({latestGuides}: GuidesContainerProps) {
    const guidesTitle = useTranslation("search_results.getbybus_guides")

    return (
        <SidebarSectionContainer
            contentArray={latestGuides}
            title={guidesTitle}
            icon={<IconGuide width={32} height={32}/>}
        >
            <BlogPosts blogPosts={latestGuides}/>
        </SidebarSectionContainer>
    );
}

export default GuidesContainer;